import { Badge } from '@hrworks/sui-core/Badge';
import { Text } from '@hrworks/sui-core/Text';

import { S } from './PersonCard.styles';
import type { PersonCardProps } from './PersonCard.types';

export const PersonCard = ({ title, subtitle, src, badgeTitle, ...otherProps }: PersonCardProps) => (
  <S.Card {...otherProps}>
    <S.Container>
      <S.PersonInfo>
        {src && <S.Image corner="circular" fullWidth={false} src={src} />}
        <div>
          {title && <Text fullWidth>{title}</Text>}
          {subtitle && <Text fullWidth>{subtitle}</Text>}
        </div>
      </S.PersonInfo>
      {badgeTitle && <Badge badgeContent={badgeTitle} />}
    </S.Container>
  </S.Card>
);
